import { pushToDataLayer } from "./tracker-googletagmanager"; 

const discovered: string[] = [];

export default class GoogleAnalytics4 {
  _code: any;
  _dataLayer: any;
  _dataLayerName: string;
  _trackIndex: number;
  _gtag: (...args: any[]) => void;
  static _lastPageViewEvents: Record<string, any> = {};

  constructor(
    code: any,
    dataLayer: any,
    dataLayerName: string,
    trackIndex = -1
  ) {
    this._code = code;
    this._dataLayer = dataLayer;
    this._dataLayerName = dataLayerName;
    this._trackIndex = trackIndex;
    this._gtag = function () {
      this._dataLayer.push(arguments);
    };
  }

  get trackIndex() {
    return this._trackIndex;
  }

  static overrideDataLayerPush(dataLayerName: string) {
    const w = window;
    const dl = w[dataLayerName];
    const fn = dl.push;
    if (fn.__ps_wrapped) return;

    dl.push = function () {
      fn.apply(w.dataLayer, arguments);
      GoogleAnalytics4.updateLastPageViewEvents();
    };
    dl.push.__ps_wrapped = true;
  }

  static updateLastPageViewEvents() {
    Object.keys(window.google_tag_manager || {})
      .filter((k) => k.startsWith("G-"))
      .forEach((k) => {
        const layer = window.google_tag_manager[k].dataLayer;
        if (layer.get("event") === "page_view") {
          GoogleAnalytics4._lastPageViewEvents[k] = layer.get("eventModel");
        }
      });
  }

  track(type, { category, ...rest }: any, trackIndex: number) {
    this._trackIndex = trackIndex;
    if (type === "event") {
      return this._trackEvent(category, rest);
    } else if (type === "page") {
      return this._trackPage(rest.url, rest.title);
    } else {
      return Promise.resolve(false);
    }
  }

  _pushToDataLayer(data: any) {
    pushToDataLayer(this._dataLayer, data);
  }

  _trackPage(url: string, title: string) {
    // wait for some time so that the gtm history event can happen before
    setTimeout(() => {
      const lastPageView = GoogleAnalytics4._lastPageViewEvents[this._code];
      // TODO this should prevent double pave view tracking in most cases, though
      // it is not perfect
      if (
        !lastPageView ||
        (lastPageView.page_location !== document.location.href &&
          lastPageView.page_location !== url)
      ) {
        this._gtag("event", "page_view", {
          page_location: url,
          page_title: title,
          send_to: this._code,
        });
      }
    }, 1000);
    return Promise.resolve(true);
  }

  _trackEvent(category: string, payload: any) {
    // TODO check if this works like this with GA4
    this._pushToDataLayer({
      event: category,
      payload,
    });
    return Promise.resolve(true);
  }

  destroy() {
    discovered.splice(discovered.indexOf(this._code), 1);
  }

  static discover(trackIndex = -1): Promise<GoogleAnalytics4[]> {
    return new Promise((resolve, reject) => {
      const w = window;
      const gtm = w.google_tag_manager;
      if (!gtm || !gtm.tidr || !gtm.tidr.container) {
        resolve([]);
      } else {
        resolve(
          Object.keys(gtm.tidr.container)
            .filter((s) => s.startsWith("G-"))
            .map((code) => {
              if (!discovered.includes(code)) {
                const dataLayerName = gtm[code].dataLayer.name;
                console.log(
                  "Discovered Google Analytics 4",
                  code,
                  dataLayerName
                );
                discovered.push(code);
                return new GoogleAnalytics4(
                  code,
                  w[dataLayerName],
                  dataLayerName,
                  trackIndex
                );
              }
              return null;
            })
            .filter(Boolean)
        );
      }
    });
  }

  /**
   * initialize general purpose things like the tracker's library js
   */
  static init() {
    return Promise.resolve();
  }

  static create({
    code,
    dataLayerName = "dataLayer",
  }: any): Promise<GoogleAnalytics4> {
    return new Promise((resolve, reject) => {
      if (~discovered.indexOf(code)) {
        resolve(null);
        return;
      }

      (function (w: any, d: any, s: string, l: string, i: string) {
        w[l] = w[l] || [];
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtag/js?id=" + i + dl;
        j.onload = () => GoogleAnalytics4.overrideDataLayerPush(l);
        f.parentNode.insertBefore(j, f);

        function gtag(...args: any[]) {
          w[l].push(arguments);
        }
        gtag("js", new Date());
        gtag("config", i, { send_page_view: false });
      })(window, document, "script", dataLayerName, code);

      window[dataLayerName] = window[dataLayerName] || [];
      discovered.push(code);
      resolve(new GoogleAnalytics4(code, window[dataLayerName], dataLayerName));
    });
  }
}



// WEBPACK FOOTER //
// ./lib/analytics/tracker-ga4.js